import {createAsyncThunk} from '@reduxjs/toolkit'

import {openNewTab} from '@web/helpers/browser'

import {ThunkApi} from '../interfaces'

const HAPPY_MONEY_JOIN_URL = `http://www.happymoney.co.kr/svc/join/memberJoin.hm`
/**
 * 해피머니 상품권 가입 페이지로 이동
 */
const navigateToHappyMoneyJoinForm = createAsyncThunk<Promise<string | unknown>, void, ThunkApi>(
    'navigateTo/happyMoneyJoinForm',
    async () => {
        openNewTab({url: HAPPY_MONEY_JOIN_URL})
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    },
)

export default navigateToHappyMoneyJoinForm
